import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

const Hero = ({ promotion, themeMode }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={6}>
        <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Box marginBottom={2}>
            <Typography
              variant="h2"
              color="textPrimary"
              sx={{ fontWeight: 700 }}
            >
              {t(`${promotion.key}.title`)}
            </Typography>
          </Box>
          <Box marginBottom={3}>
            <Typography variant="h6" component="p" color="textSecondary">
              {t(`${promotion.key}.text`)}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        container
        alignItems={'center'}
        justifyContent={'center'}
        xs={12}
        md={6}
        data-aos={isMd ? 'fade-left' : 'fade-up'}
      >
        <Box
          component={LazyLoadImage}
          height={'100%'}
          width={'100%'}
          src={'dark' == themeMode? promotion.image_dark_uri: promotion.image_light_uri}
          alt={t(`${promotion.key}.image_alt`)}
          effect="blur"
          boxShadow={0}
          borderRadius={4}
          maxWidth={500}
        />
      </Grid>
    </Grid>
  );
};

export default Hero;
